import { gql } from '@apollo/client';

const APPLICATION_PAYMENT = gql`
  fragment applicationPayment on Application {
    payment_info {
      # code
      amount
      currency
      coupon
      discount
      fee
      payment_option
      is_external
      discount_percent
      created_at
    }
  }
`;

const APPLICATION_REVIEW = gql`
  fragment applicationReview on Application {
    id
    createdAt


  }
`;

const APPLICATION_ELEMENT = gql`
  fragment applicationElement on ApplicationElement {
      field_id
      field_name
      type
      subtype
      order
      value
      child_elements {
        field_id
        field_name
        type
        subtype
        order
        value
      }
  }
`;
const APPLICATION_SCALAR_ELEMENT = gql`
  fragment applicationScalarElement on ApplicationScalarElement {
      field_id
      field_name
      type
      subtype
      order
      value
      child_elements {
        field_id
        field_name
        type
        subtype
        order
        value
      }
  }
`;

const APPLICATION_REVIEWER = gql`
  fragment applicationReviewer on Application {
      id
      application_review_id
      namea
      email
      review_status
      is_scientist
      is_verified
      has_reviews
  }
`;

const ApplicationFragments = {
  applicationPayment: APPLICATION_PAYMENT,
  applicationReview: APPLICATION_REVIEW,
  applicationReviewer: APPLICATION_REVIEWER,
  applicationElement: APPLICATION_ELEMENT,
  applicationScalarElement: APPLICATION_SCALAR_ELEMENT,
};

export default ApplicationFragments;
